import { useQuery } from 'react-query';
import TradeListPaymentsOnHold from '../../models/TradeListPaymentsOnHold';
import MergedTradeListPaymentsOnHold from '../../models/MergedTradeListPaymentsOnHold';
import { ACTIVITY } from '../../constants/queryDefinition';
import ActivityService from '../../../services/ActivityService';

const activityService = ActivityService.get();

const usePaymentsOnHoldTradeList = (
  requestBody,
  etrPaymentsOnHold,
  options
) => {
  const queryPaymentOnHoldTradeList = async () => {
    const serviceResponse = await activityService.getPaymentsOnHoldTradeList(
      requestBody
    );
    return serviceResponse;
  };

  const response = useQuery(
    [ACTIVITY.GET_PAYMENT_ON_HOLD_TRADE_LIST.KEY, requestBody],
    queryPaymentOnHoldTradeList,
    {
      staleTime: ACTIVITY.GET_PAYMENT_ON_HOLD_TRADE_LIST.STALE_TIME,
      cacheTime: ACTIVITY.GET_PAYMENT_ON_HOLD_TRADE_LIST.STALE_TIME,
      enabled: true,
      retry: false
    }
  );

  const data = response?.data?.tradesWithPaymentsOnHold;

  if (options?.isMergedPaymentsOnHoldEnabled) {
    return data || etrPaymentsOnHold
      ? new MergedTradeListPaymentsOnHold(data, etrPaymentsOnHold, {
          sortId: requestBody?.sort?.id,
          filterId: requestBody?.dataFilter?.id,
          tradesOnPage: options?.tradesOnPage,
          etrOffset: options?.etrOffset
        })
      : null;
  }

  return data ? new TradeListPaymentsOnHold(data) : null;
};

export default usePaymentsOnHoldTradeList;
